import clsx from "clsx";
import { PhoneIcon } from "ui/iconsN";

type Props = {
  isHeaderTransparent: boolean;
  onClick?: () => void;
  className?: string;
};
export const PhoneHeader = ({ isHeaderTransparent, onClick, className }: Props) => {
  return (
    <div className={clsx("relative group", className)}>
      <a
        href="tel:+33145619090"
        className={clsx(
          "h-12 rounded-lg px-4 no-underline whitespace-nowrap flex items-center gap-3 border transition-colors",
          {
            "text-pr-1 stroke-pr-1 border-pr-1 bg-white": !isHeaderTransparent,
            "text-white stroke-white border-white/20 bg-white/10 backdrop-blur-lg": isHeaderTransparent,
          },
          "hover:text-white hover:stroke-white",
          "[clip-path:inset(0px_round_8px)]",
        )}
        onClick={onClick}
      >
        <div className="absolute -bottom-1 left-1/2 w-[200%] aspect-square btn-phone-nav rounded-full -translate-x-1/2 translate-y-1/2 transition-transform scale-0 group-hover:scale-100" />
        <div
          className={clsx(
            "absolute -inset-px border rounded-lg transition-colors group-hover:shadow-[0_-1.5px_0_0_rgba(120,40,3,0.24)_inset,0_1.5px_0_0_rgba(242,144,108,0.32)_inset]",
            {
              "border-pr-1": !isHeaderTransparent,
              "border-white/20": isHeaderTransparent,
            },
            "group-hover:border-pr-2",
          )}
        />
        <PhoneIcon className="z-10 group-hover:drop-shadow-sm" />
        <span className="text-sm font-semibold z-10 group-hover:drop-shadow-sm">01 45 61 90 90</span>
      </a>
      <div
        className={clsx(
          "bg-primary rounded-lg text-white hidden group-hover:block text-sm font-medium left-1/2 p-2 absolute text-center top-[calc(100%+12px)] -translate-x-1/2 whitespace-nowrap z-50",
          "after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-full after:border-[5px] after:border-transparent after:border-b-primary",
        )}
      >
        <p>Nous restons à votre écoute</p>
        <p>du lundi au jeudi entre 9h30-18h00</p>
        <p>et le vendredi entre 9h30-17h00</p>
      </div>
    </div>
  );
};
